import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './components/login/login.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RegisterComponent } from './components/register/register.component';
import { SelectModule } from "src/app/components/shares/select/select.module";
import { NgxIntlTelInputModule } from "src/app/components/shares/ngx-intl-input/ngx-intl-tel-input.module";
import { DatePickerLocaleModule } from "src/app/components/shares/date-picker-locale/date-picker-locale.module";

@NgModule({
  declarations: [LoginComponent, RegisterComponent],
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    TranslateModule,
    SelectModule,
    NgxIntlTelInputModule,
    DatePickerLocaleModule
],
  exports: [LoginComponent, RegisterComponent],
})
export class LoginModule {}
